import { USER_LOGOUT } from '../action-creators/ProfileActionCreators';
import { AI_TOOLS_CONTENT_UPDATE, AI_TOOLS_OPEN } from '../action-creators/ai-tools';
import { IAiAssistantContent } from '../../views/Pages/AiAssistant/models/ai-assistant.models';

interface InitialState {
	aiToolsOpen: boolean;
	aiAssistantContent: IAiAssistantContent | null;
}

const initialState: InitialState = {
	aiToolsOpen: false,
	aiAssistantContent: {
		main_title: { current_content: null, extracted_content: [] },
		seo_title: { current_content: null, extracted_content: [] },
		summary: { current_content: null, extracted_content: [] },
		article: null,
	},
};

function aiToolsReducer(state = initialState, action: any): InitialState {
	switch (action.type) {
		case AI_TOOLS_OPEN:
			return {
				...state,
				aiToolsOpen: action.payload.aiToolsOpen,
			};

		case AI_TOOLS_CONTENT_UPDATE:
			return {
				...state,
				aiAssistantContent: {
					...state.aiAssistantContent,
					...action.payload.aiAssistantContent,
				},
			};

		case USER_LOGOUT:
			return initialState;

		default:
			return state;
	}
}

export default aiToolsReducer;
